import { Size } from "@brightagency/headstart-common";
import { useCallback, useEffect, useState } from "react";
import { colors } from "../utils/colors";
import { useBreakpoint } from ".";

/**
 * Internal implementation to set the current theme colour
 */
export const _setThemeColor = (color: string) => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
        meta.setAttribute("content", color);
    }
};

const colorMap: { [key: string]: ThemeColors } = {
    mobile: {
        loading: colors.brandDark,
        default: colors.brandMid,
        modal: colors.brandDark,
        needHelpNow: colors.brandDark,
    },
    desktop: {
        loading: colors.brandDark,
        default: colors.brandDark,
        modal: colors.brandDark,
        needHelpNow: colors.brandMid,
    },
};

const getColors = (isLarge: boolean) => {
    if (isLarge) {
        return colorMap.desktop;
    } else {
        return colorMap.mobile;
    }
};

export type ThemeColors = {
    loading: string;
    default: string;
    modal: string;
    needHelpNow: string;
};

export const useThemeColors = () => {
    const isLarge = useBreakpoint(Size.large);
    const [themeColors, setThemeColors] = useState(getColors(isLarge));

    const setThemeColor = useCallback(
        (fn: (themeColors: ThemeColors) => string) => {
            _setThemeColor(fn(themeColors));
        },
        [themeColors],
    );

    useEffect(() => {
        setThemeColors(getColors(isLarge));
    }, [isLarge]);

    return { themeColors, setThemeColor };
};
